import InstitutionDoctors from "./InstitutionDoctors.vue";

export default {
  extends: InstitutionDoctors
};
